import { HiXMark } from "react-icons/hi2";

/** Размер кнопки: окно закрывают крупной, метку в строке — компактной. */
type CloseButtonSize = "md" | "sm";

/**
 * Оформление: `surface` — отдельная кнопка на поверхности карточки,
 * `ghost` — кнопка внутри уже окрашенного элемента (метка упоминания,
 * строка выбранного файла), которая наследует его цвет и не спорит с ним рамкой.
 */
type CloseButtonTone = "surface" | "ghost";

/**
 * Единственный крестик интерфейса.
 *
 * Раньше рядом жили три разных крестика: окно закрывали этим компонентом, а
 * метки упоминаний и выбранные файлы — самодельными кнопками со своей
 * геометрией. Выглядели они по-разному и ломались на узких экранах, поэтому
 * компонент умеет оба размера и оба оформления, а сами места применения
 * больше не описывают кнопку с нуля.
 */
export function CloseButton({
  label = "Закрыть",
  onClick,
  size = "md",
  tone = "surface",
  disabled = false,
}: {
  label?: string;
  onClick: () => void;
  size?: CloseButtonSize;
  tone?: CloseButtonTone;
  disabled?: boolean;
}) {
  return (
    <button
      className={`close-control close-control--${size} close-control--${tone}`}
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
    >
      <HiXMark aria-hidden="true" />
    </button>
  );
}
